var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex flex-wrap"},_vm._l((_vm.count),function(i){return _c('v-skeleton-loader',{key:i,staticClass:"mx-auto my-4",attrs:{"type":"card-avatar","width":"300","tile":""}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }